import { useModalStore } from "@/stores/use-modal-store";
import { XMarkIcon } from "@heroicons/react/20/solid";
import MemoryScoreTooltipImg from "@/assets/report-assets/memory-score-tooltip.png";

/*
 * MemoryScoreTitleInfoModal component
 *
 * This modal displays information about the Memory score and its gradient scale.
 */
export const MemoryScoreInfoModal = () => {
  /* Hooks */
  const { close } = useModalStore((state) => state.modalActions);

  /* Render */
  return (
    <div className="flex flex-col gap-6">
      {/* Header */}
      <div className="flex items-center justify-center relative">
        <h2>Memory score</h2>
        <XMarkIcon onClick={close} className="size-5 cursor-pointer absolute right-0" />
      </div>

      {/* Memory score tooltip image */}
      <div className="flex items-center justify-center">
        <img src={MemoryScoreTooltipImg} alt="Memory score visualization" className="w-full max-w-lg rounded-lg" />
      </div>

      {/* Description */}
      <p className="text-center">
        Memory score measures the probability of an asset being retained in viewer&apos;s memory and is derived from multiple factors such as branding, visuals, text, attention and
        visibility.
      </p>

      {/* Gradient Scale */}
      <div className="flex flex-col gap-4">
        {/* Gradient Bar with Labels */}
        <div className="flex items-center gap-4">
          <span className="text-xl font-bold">0%</span>
          <div className="flex-1 h-4 rounded-full" style={{ background: "linear-gradient(to right, #ef4444, #f97316, #eab308, #84cc16, #22c55e, #10b981)" }}></div>
          <span className="text-xl font-bold">100%</span>
        </div>

        {/* Scale Labels */}
        <div className="flex items-start justify-between gap-20 mt-2">
          <div className="flex-1 text-left">
            <p className="font-medium text-base text-center">Low probability asset will be retained in memory</p>
          </div>
          <div className="flex-1 text-right">
            <p className="font-medium text-base text-center">High probability asset will be retained in memory</p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <p className="text-center text-xs text-base-content/60 px-10">
        Scores are based on Dragonfly Memorability Model which was trained on 60k images and tested with 1200 individuals.
      </p>
    </div>
  );
};
